import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const PrivateRoute = ({ children }) => {
  const { token, isLoading } = useUser();

  if (isLoading) {
    return <div className="text-center mt-12 text-gray-600">Cargando sesión...</div>;
  }

  return token ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
